var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9.58398,
    width: 20,
    height: 1,
    fill: "#FFA556"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.417,
    width: 20,
    height: 1,
    transform: "rotate(90 10.417 0)",
    fill: "#FFA556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.97df8506d5241be74972558745462b20.svg";
export { ForwardRef as ReactComponent };